<script setup>
import EmailingForm from '@frontJs/components/forms/projectManagement/modules/EmailingForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const {
    tenant,
    emailing,
    emailingVariableInformation,
    emailingContactDataTypes,
    emailingExclusionDataTypes,
} = defineProps({
    tenant: {
        type: Object,
        required: false,
    },
    emailing: {
        type: Object,
        required: false,
    },
    emailingVariableInformation: {
        type: Object,
        required: false,
    },
    emailingContactDataTypes: {
        type: Array,
        required: true,
    },
    emailingExclusionDataTypes: {
        type: Array,
        required: true,
    },
    semSegmentations: {
        type: Array,
        required: true,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="emailing">
            Mettre à jour l'emailing #{{ emailing.id }} - Emailings - Modules -
            Gestion de projet - Datakepler
        </title>

        <title v-else>
            Créer un emailing - Emailings - Modules - Gestion de projet -
            Datakepler
        </title>
    </Head>

    <PageTitle v-if="emailing" :tenant-name="tenant.name">
        Gestion de projet - Modules - Emailings - Mettre à jour l'emailing #{{
            emailing.id
        }}
    </PageTitle>

    <PageTitle v-else :tenant="tenant.name">
        Gestion de projet - Modules - Emailings - Créer un emailing
    </PageTitle>

    <EmailingForm
        :tenant="tenant"
        :emailing="emailing"
        :emailing-variable-information="emailingVariableInformation"
        :emailing-contact-data-types="emailingContactDataTypes"
        :emailing-exclusion-data-types="emailingExclusionDataTypes"
        :sem-segmentations="semSegmentations"
    />
</template>
